// extracted by mini-css-extract-plugin
export default {"section":"OurTeam_section__PEp0H","intro":"OurTeam_intro__v2Zur","quotes":"OurTeam_quotes__iptvd","quote":"OurTeam_quote__1ZEvt"};